import { useState } from 'react';
import { Col, Form, FormGroup, Label, Input, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { H6, Image, Btn } from 'AbstractElements';
import { useSelector, useDispatch } from 'react-redux';
import { setField } from 'Features/Learning/Tryout/addTryoutSlice';
import { useEffect } from 'react';
import RichEditor from 'Component/Editor/RichEditor/RichEditor';
import Moment from 'moment';
import 'moment/locale/id';
import { handleWheel } from 'Utils/handleWheel';
import "./tryout.css"

const MateriForm = () => {
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [lockedUntilDate, setLockedUntilDate] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalStageIdx, setModalStageIdx] = useState(null);
  const [tempInstruction, setTempInstruction] = useState('');
  const dispatch = useDispatch()
  const data = useSelector(state => state.addTryout)

  // Sinkronkan time dengan total durasi TOEFL jika is_toefl aktif
  useEffect(() => {
    if (data.is_toefl == '1' && Array.isArray(data.toefl_setup)) {
      const total = data.toefl_setup.reduce((acc, curr) => {
        const dur = parseInt(curr.duration) || 0;
        const brk = parseInt(curr.break) || 0;
        return acc + dur + brk;
      }, 0);
      if (data.time !== String(total)) {
        dispatch(setField({ field: 'time', value: String(total) }));
      }
    }
  }, [data.is_toefl, data.toefl_setup]);

  // Jika tryout adalah LIVE, non-aktifkan opsi TOEFL dan set duration otomatis besar
  useEffect(() => {
    const AUTO_LIVE_TIME = '99999';
    if (data.is_live == '1' || data.is_live === true) {
      // pastikan is_toefl dimatikan
      if (data.is_toefl !== '0') {
        dispatch(setField({ field: 'is_toefl', value: '0' }));
      }
      // set time ke nilai besar agar tidak mengganggu tampilan/perhitungan lain
      if (data.time !== AUTO_LIVE_TIME) {
        dispatch(setField({ field: 'time', value: AUTO_LIVE_TIME }));
      }
    } else {
      // jika sebelumnya otomatis di-set, kembalikan menjadi kosong agar user bisa isi kembali
      if (data.time === AUTO_LIVE_TIME) {
        dispatch(setField({ field: 'time', value: '' }));
      }
    }
  }, [data.is_live, dispatch, data.is_toefl, data.time]);

  // Jika tryout adalah LIVE, pastikan is_report_show dimatikan (set ke '0')
  useEffect(() => {
    if (data.is_live == '1' || data.is_live === true) {
      if (data.is_report_show !== '0') {
        dispatch(setField({ field: 'is_report_show', value: '0' }));
      }
    }
  }, [data.is_live, data.is_report_show, dispatch]);

  // Jika tryout adalah TOEFL, non-aktifkan opsi LIVE dan pastikan LIVE = '0'
  useEffect(() => {
    if (data.is_toefl == '1' || data.is_toefl === true) {
      if (data.is_live !== '0') {
        dispatch(setField({ field: 'is_live', value: '0' }));
      }
    }
  }, [data.is_toefl, dispatch]);

  // Set break pada stage terakhir otomatis 0 setiap kali jumlah stage berubah
  useEffect(() => {
    if (data.is_toefl == '1' && Array.isArray(data.toefl_setup) && data.toefl_setup.length > 0) {
      const lastIdx = data.toefl_setup.length - 1;
      if (data.toefl_setup[lastIdx].break !== 0 && data.toefl_setup[lastIdx].break !== '0') {
        const updatedStages = [...data.toefl_setup];
        updatedStages[lastIdx] = { ...updatedStages[lastIdx], break: 0 };
        dispatch(setField({ field: 'toefl_setup', value: updatedStages }));
      }
    }
  }, [data.toefl_setup.length]);

  const handleStartDate = date => {
    setstartDate(date);
    if (date === null) {
      dispatch(setField({ field: 'start_at', value: '' }));
    } else {
      dispatch(setField({ field: 'start_at', value: Moment(date).format('yyyy-MM-DD HH:mm:ss') }));
    }
  };

  const handleKeyDown = (e) => {
    // Hanya izinkan input angka (0-9) dan backspace
    const isValidInput = /^[0-9\b]+$/.test(e.key);

    if (!isValidInput && e.key !== 'Backspace') {
      e.preventDefault();
    }
  };

  const handleEndDate = date => {
    setendDate(date);
    if (date === null) {
      dispatch(setField({ field: 'end_at', value: '' }));
    } else {
      dispatch(setField({ field: 'end_at', value: Moment(date).format('yyyy-MM-DD HH:mm:ss') }));
    }
  };

  const handleLockedUntilDate = date => {
    setLockedUntilDate(date);
    if (date === null) {
      dispatch(setField({ field: 'locked_until_at', value: '' }));
    } else {
      dispatch(setField({ field: 'locked_until_at', value: Moment(date).format('yyyy-MM-DD HH:mm:ss') }));
    }
  };

  const handleChangeLockedMessage = (e) => {
    // Ensure value tidak null, minimal empty string
    const value = e === null || e === undefined ? '' : e;
    dispatch(setField({ field: 'locked_message', value: value }));
  };

  const handleChanges = (e) => {
    const { name, value } = e.target;
    dispatch(setField({ field: name, value: value }));
  }
  const handleChangeDescription = (e) => {
    dispatch(setField({ field: 'description', value: e }));
  }
  const handleChangeInstruction = (e) => {
    dispatch(setField({ field: 'instruction', value: e }));
  }

  useEffect(() => {
    const selectedStart = data.start_at
      ? Moment(data.start_at, 'YYYY-MM-DD HH:mm:ss').toDate()
      : null;
    setstartDate(selectedStart);
    const selectedEnd = data.end_at
      ? Moment(data.end_at, 'YYYY-MM-DD HH:mm:ss').toDate()
      : null;
    setendDate(selectedEnd);
    const selectedLockedUntil = data.locked_until_at
      ? Moment(data.locked_until_at, 'YYYY-MM-DD HH:mm:ss').toDate()
      : null;
    setLockedUntilDate(selectedLockedUntil);
  }, [data.start_at, data.end_at, data.locked_until_at]);

  // Handler untuk stages
  const handleChangeStage = (e, index, field) => {
    const { value } = e.target;
    const updatedStages = [...(data.toefl_setup || [])];
    updatedStages[index] = { ...updatedStages[index], [field]: value };
    dispatch(setField({ field: 'toefl_setup', value: updatedStages }));
  };

  const handleAddStage = () => {
    const updatedStages = data.toefl_setup ? [...data.toefl_setup] : [];
    updatedStages.push({ name: '', instructions: '', total_questions: '', duration: '', break: '' });
    dispatch(setField({ field: 'toefl_setup', value: updatedStages }));
  };

  const handleRemoveStage = (index) => {
    const updatedStages = [...(data.toefl_setup || [])];
    updatedStages.splice(index, 1);
    dispatch(setField({ field: 'toefl_setup', value: updatedStages }));
  };

  // Hitung total durasi tryout jika is_toefl aktif
  let totalToeflDuration = '';
  if (data.is_toefl == '1' && Array.isArray(data.toefl_setup)) {
    totalToeflDuration = data.toefl_setup.reduce((acc, curr) => {
      const dur = parseInt(curr.duration) || 0;
      const brk = parseInt(curr.break) || 0;
      return acc + dur + brk;
    }, 0);
  }

  // Modal open handler
  const handleOpenInstructionModal = (index) => {
    setModalStageIdx(index);
    setTempInstruction(data.toefl_setup[index]?.instructions || '');
    setModalOpen(true);
  };

  // Modal save handler
  const handleSaveInstruction = () => {
    if (modalStageIdx !== null) {
      const updatedStages = [...(data.toefl_setup || [])];
      updatedStages[modalStageIdx] = {
        ...updatedStages[modalStageIdx],
        instructions: tempInstruction
      };
      dispatch(setField({ field: 'toefl_setup', value: updatedStages }));
    }
    setModalOpen(false);
    setModalStageIdx(null);
    setTempInstruction('');
  };

  // Modal close handler
  const handleCloseModal = () => {
    setModalOpen(false);
    setModalStageIdx(null);
    setTempInstruction('');
  };

  return (
    <Form className="row needs-validation">
      <H6 attrH6={{ className: "mb-3", color: data?.is_tryout_used ? "red" : "black" }}>{data?.is_tryout_used ? "Tryout sudah ada yang mengerjakan" : ""}</H6>
      <Col sm="12">
        <FormGroup className='mb-3'>
          <Label for="validationTitle" style={{ fontWeight: 'bold' }}>{'Judul Tryout'}:</Label>
          <Input className="form-control" id="validationTitle" type="text" name="title" placeholder="Nama Tryout" required=""
            value={data.title}
            onChange={handleChanges} />
        </FormGroup>
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>Apakah Tryout ini digunakan untuk Kuis?</Label>
          <div className="m-checkbox-inline">
            <Label for="is_quiz_true">
              <Input className="radio_animated" id="is_quiz_true" type="radio" name="is_quiz" value="1"
                checked={data.is_quiz == '1'}
                onChange={handleChanges} />{'Ya'}
            </Label>
            <Label for="is_quiz_false">
              <Input className="radio_animated" id="is_quiz_false" type="radio" name="is_quiz" value="0"
                checked={data.is_quiz == '0'}
                onChange={handleChanges} />{'Tidak'}
            </Label>
          </div>
        </FormGroup>
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>Apakah Tryout ini adalah <b>LIVE</b>?</Label>
          <div className="m-checkbox-inline">
            <Label for="is_live_true">
              <Input className="radio_animated" id="is_live_true" type="radio" name="is_live" value="1"
                checked={data.is_live == '1'}
                onChange={handleChanges}
                // disable if it's TOEFL or update lock
                disabled={data.is_toefl == '1' || (data.is_live == '0' && data.isUpdate)} />{'Ya'}
            </Label>
            <Label for="is_live_false">
              <Input className="radio_animated" id="is_live_false" type="radio" name="is_live" value="0"
                checked={data.is_live == '0'}
                onChange={handleChanges}
                disabled={data.is_toefl == '1' || (data.is_live == '1' && data.isUpdate)} />{'Tidak'}
            </Label>
          </div>
        </FormGroup>
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>Apakah Tryout ini ditampilkan pada laporan siswa?</Label>
          <div className="m-checkbox-inline">
            <Label for="is_report_show_true">
              <Input className="radio_animated" id="is_report_show_true" type="radio" name="is_report_show" value="1"
                checked={data.is_report_show == '1'}
                onChange={handleChanges}
                disabled={data.is_live == '1' || data.is_live === true}
              />{'Ya'}
            </Label>
            <Label for="is_report_show_false">
              <Input className="radio_animated" id="is_report_show_false" type="radio" name="is_report_show" value="0"
                checked={data.is_report_show == '0'}
                onChange={handleChanges}
                disabled={data.is_live == '1' || data.is_live === true}
              />{'Tidak'}
            </Label>
          </div>
        </FormGroup>
        <FormGroup className='mb-3'>
          <Label for="validationImage" style={{ fontWeight: 'bold' }}>Apakah Tryout ini adalah TOEFL?</Label>
          <div className="m-checkbox-inline">
            <Label for="is_toefl_true">
              <Input className="radio_animated" id="is_toefl_true" type="radio" name="is_toefl" value="1"
                checked={data.is_toefl == '1'}
                onChange={handleChanges}
                // disable when live or when update logic requires it
                disabled={data.is_live == '1' || (data.is_toefl == '0' && data.is_tryout_used)} />{'Ya'}
            </Label>
            <Label for="is_toefl_false">
              <Input className="radio_animated" id="is_toefl_false" type="radio" name="is_toefl" value="0"
                checked={data.is_toefl == '0'}
                onChange={handleChanges}
                disabled={data.is_live == '1' || (data.is_toefl == '1' && data.is_tryout_used)} />{'Tidak'}
            </Label>
          </div>
        </FormGroup>
        {
          data.is_toefl == '1' && (
            <>
              {data.toefl_setup && data.toefl_setup.map((setup, index) => (
                <FormGroup key={index} className='mb-3 border p-3 rounded'>
                  <Row>
                    <Col md={4}>
                      <Label style={{ fontWeight: 'bold' }}>Nama Stage:</Label>
                      <Input
                        className="form-control"
                        type="text"
                        name="name"
                        placeholder="Nama Stage"
                        required
                        value={data?.toefl_setup[index].name || ''}
                        onChange={e => handleChangeStage(e, index, 'name')}
                        disabled={data.is_tryout_used}
                      />
                    </Col>
                    <Col md={2}>
                      <Label style={{ fontWeight: 'bold' }}>Total Soal:</Label>
                      <Input
                        className="form-control"
                        type="number"
                        onWheel={handleWheel}
                        name="total_questions"
                        placeholder="Total Soal"
                        required
                        value={data?.toefl_setup[index].total_questions || ''}
                        onChange={e => handleChangeStage(e, index, 'total_questions')}
                        disabled={data.is_tryout_used}
                      />
                    </Col>
                    <Col md={2}>
                      <Label style={{ fontWeight: 'bold' }}>Durasi (menit):</Label>
                      <Input
                        className="form-control"
                        type="number"
                        onWheel={handleWheel}
                        name="duration"
                        placeholder="Durasi"
                        required
                        value={data?.toefl_setup[index].duration || ''}
                        onChange={e => handleChangeStage(e, index, 'duration')}
                        disabled={data.is_tryout_used}
                      />
                    </Col>
                    <Col md={2}>
                      <Label style={{ fontWeight: 'bold' }}>Break (menit):</Label>
                      <Input
                        className="form-control"
                        type="number"
                        onWheel={handleWheel}
                        name="break"
                        placeholder="Break"
                        required
                        value={index === data.toefl_setup.length - 1 ? 0 : (data?.toefl_setup[index].break || '')}
                        onChange={index === data.toefl_setup.length - 1 ? undefined : (e => handleChangeStage(e, index, 'break'))}
                        disabled={index === data.toefl_setup.length - 1 || data.is_tryout_used}
                      />
                    </Col>
                    <Col md={2} className="d-flex align-items-end">
                      {/* Tombol Instruksi Break */}
                      {index !== data.toefl_setup.length - 1 && (
                        <Btn
                          attrBtn={{
                            color: 'info',
                            outline: false,
                            className: 'p-1 me-2 d-flex align-items-center',
                            onClick: () => handleOpenInstructionModal(index),
                            // disabled: data.is_tryout_used
                          }}
                          title="Instruksi Break"
                        >
                          {setup.instructions && setup.instructions.trim() !== '' ? (
                            <>
                              <i className="fa fa-check-circle fa-2x me-1"></i>
                              <span className="fw-bold">Instruksi</span>
                            </>
                          ) : (
                            <>
                              <i className="fa fa-times-circle fa-2x me-1"></i>
                              <span className="fw-bold">Instruksi</span>
                            </>
                          )}
                        </Btn>
                      )}
                      {/* Tombol Remove */}
                      {index > 0 && (
                        <Btn
                          attrBtn={{
                            color: 'link',
                            outline: true,
                            className: 'p-1',
                            onClick: () => handleRemoveStage(index),
                            disabled: data.is_tryout_used
                          }}
                        >
                          <i className="fa fa-close mx-auto text-danger fa-2x"></i>
                        </Btn>
                      )}
                    </Col>
                  </Row>
                </FormGroup>
              ))}
              {/* Modal Instruksi Break */}
              <Modal isOpen={modalOpen} toggle={handleCloseModal} size='lg' className="toefl-modal" modalClassName="toefl-modal-dialog">
                <ModalHeader toggle={handleCloseModal}>Instruksi Break</ModalHeader>
                <ModalBody>
                  <Label>Masukkan instruksi break (tidak wajib):</Label>
                  <RichEditor id="validationDescription" handleChangeDescription={e => setTempInstruction(e)} description={tempInstruction} />
                </ModalBody>
                <ModalFooter>
                  <Btn attrBtn={{ color: 'primary', onClick: handleSaveInstruction }}>Simpan</Btn>
                  <Btn attrBtn={{ color: 'secondary', onClick: handleCloseModal }}>Batal</Btn>
                </ModalFooter>
              </Modal>
              <FormGroup className='mb-3'>
                <Btn
                  attrBtn={{
                    color: 'link',
                    outline: true,
                    className: 'p-1',
                    onClick: () => handleAddStage(),
                    disabled: data.is_tryout_used
                  }}
                >
                  <i className="fa fa-plus-circle mx-auto fa-2x" style={{ color: '#3C6F7D' }}></i>
                </Btn>
              </FormGroup>
            </>
          )
        }
        <FormGroup className='mb-3'>
          <Label for="validationDuration" style={{ fontWeight: 'bold' }}>{'Durasi Pengerjaan Tryout'}:</Label>
          <Input
            className="form-control"
            id="validationDuration"
            type="text"
            name="time"
            placeholder="Lama waktu dalam menit"
            required
            value={data.is_live == '1' ? data.time : (data.is_toefl == '1' ? totalToeflDuration : data.time)}
            onChange={(data.is_live == '1' || data.is_toefl == '1') ? undefined : handleChanges}
            onKeyDown={(data.is_live == '1' || data.is_toefl == '1') ? undefined : handleKeyDown}
            disabled={data.is_toefl == '1' || data.is_live == '1' || data.is_tryout_used}
          />
        </FormGroup>
        <FormGroup className='mb-3'>
          <Row>
            <Col>
              <Label for="validationStarted" style={{ fontWeight: 'bold', marginRight: '5px' }}>{'Waktu Mulai'} : </Label>
              <DatePicker
                className="form-control digits"
                showPopperArrow={false}
                selected={startDate}
                showTimeSelect
                timeFormat="HH:mm:ss"
                dateFormat="yyyy-MM-dd HH:mm:ss"
                closeOnScroll={true}
                onChange={handleStartDate}
                isClearable
                placeholderText="Pilih waktu mulai!"
              />
            </Col>
            <Col>
              <Label for="validationEnded" style={{ fontWeight: 'bold', marginRight: '5px' }}>{'Waktu Berakhir'} : </Label>
              <DatePicker
                className="form-control digits"
                showPopperArrow={false}
                selected={endDate}
                showTimeSelect
                timeFormat="HH:mm:ss"
                dateFormat="yyyy-MM-dd HH:mm:ss"
                closeOnScroll={true}
                onChange={handleEndDate}
                isClearable
                placeholderText="Pilih waktu berakhir!"
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup className='mb-3'>
          <Label for="validationQuotas" style={{ fontWeight: 'bold' }}>{'Kuota Peserta Tryout'}:</Label>
          <Input className="form-control" id="validationQuotas" type="text" name="quotas" placeholder="Jumlah maksimal peserta" required=""
            value={data.quotas}
            onChange={handleChanges}
            onKeyDown={handleKeyDown} />
        </FormGroup>
        {/* Lock Tryout Feature */}
        <FormGroup className='mb-3'>
          <Label for="lockedType" style={{ fontWeight: 'bold' }}>Tipe Kunci Tryout:</Label>
          <select
            id="lockedType"
            className="form-control selectpicker"
            name="locked_type"
            value={data.locked_type || 'none'}
            onChange={handleChanges}
          >
            <option value="none">Tidak Ada Kunci</option>
            <option value="analytics">Analytics</option>
            <option value="ranking">Ranking</option>
            <option value="both">Keduanya (Analytics + Ranking)</option>
          </select>
        </FormGroup>
        {/* Conditional: Show locked_until_at and locked_message only if locked_type is not 'none' */}
        {data.locked_type && data.locked_type !== 'none' && (
          <>
            <FormGroup className='mb-3'>
              <Label for="lockedUntilAt" style={{ fontWeight: 'bold', marginRight: '5px' }}>Terkunci Hingga:</Label>
              <DatePicker
                className="form-control digits"
                id="lockedUntilAt"
                showPopperArrow={false}
                selected={lockedUntilDate}
                showTimeSelect
                timeFormat="HH:mm:ss"
                dateFormat="yyyy-MM-dd HH:mm:ss"
                closeOnScroll={true}
                onChange={handleLockedUntilDate}
                isClearable
                placeholderText="Pilih waktu unlock!"
              />
            </FormGroup>
            <FormGroup className='mb-3'>
              <Label for="lockedMessage" style={{ fontWeight: 'bold' }}>Pesan Kunci: <span style={{ color: 'red' }}>*</span></Label>
              <RichEditor
                id="lockedMessage"
                handleChangeDescription={handleChangeLockedMessage}
                description={data.locked_message}
              />
            </FormGroup>
          </>
        )}
        <FormGroup className='mb-3'>
          <Label for="validationDescription" style={{ fontWeight: 'bold' }}>{'Description'}:</Label>
          <RichEditor id="validationDescription" handleChangeDescription={handleChangeDescription} description={data.description} />
        </FormGroup>
        {/* <FormGroup className='mb-3'>
            <Label for="validationDescription" style={{ fontWeight: 'bold' }}>{'Instruksi'}:</Label>
            <RichEditor id="validationDescription" handleChangeDescription={handleChangeInstruction} description={data.instruction} />
          </FormGroup> */}
        {data.bannerLink && (
          <FormGroup className='mb-3'>
            <Image attrImage={{ className: 'img-fluid', width: '500px', src: data.bannerLink, alt: data.title }} />
          </FormGroup>
        )}
      </Col>
    </Form>
  );
};
export default MateriForm;